module.exports = __webpack_public_path__ + "img/recommend1.62ca2271.png";